import useInfiniteScroll from 'react-infinite-scroll-hook'

type InfiniteScrollListProps = {
  hasNextPage?: boolean
  loading?: boolean
  onLoadMore: () => void
  disabled?: boolean
  children: React.ReactNode
}
export function InfiniteScrollList({
  hasNextPage = false,
  loading = false,
  onLoadMore,
  disabled = false,
  children
}: InfiniteScrollListProps) {
  const [sentryRef] = useInfiniteScroll({
    loading,
    hasNextPage,
    onLoadMore,
    disabled
  })

  return (
    <>
      {children}
      {hasNextPage && <div className="flex w-full border" ref={sentryRef} />}
    </>
  )
}
